import React from "react";
import { Box, Tooltip } from "@mui/material";

// The chart's series as swatch-and-label pairs, in drawing order. Text stays
// in ink; the swatch carries the color. A folded series lists what it holds.
// With `onToggle` each entry is a button that hides or shows its series.
export const ChartLegend = ({ items, hidden, onToggle }) => (
  <Box
    component="ul"
    aria-label="Legend"
    sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", columnGap: 2, rowGap: 0.5, m: 0, p: 0, listStyle: "none" }}
  >
    {items.map((item) => {
      const off = hidden?.has(item.key);
      const swatch = (
        <Box
          component="span"
          sx={{
            width: 10,
            height: 10,
            borderRadius: 0.5,
            flexShrink: 0,
            bgcolor: off ? "transparent" : item.color,
            border: 2,
            borderColor: item.color,
          }}
        />
      );
      const content = onToggle ? (
        <Box
          component="button"
          type="button"
          aria-pressed={!off}
          onClick={() => onToggle(item.key)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.75,
            font: "inherit",
            fontSize: 12,
            color: off ? "text.disabled" : "text.primary",
            textDecoration: off ? "line-through" : "none",
            bgcolor: "transparent",
            border: 0,
            p: 0.25,
            cursor: "pointer",
            borderRadius: 0.5,
            "&:hover": { bgcolor: "action.hover" },
          }}
        >
          {swatch}
          {item.label}
        </Box>
      ) : (
        <Box component="span" sx={{ display: "flex", alignItems: "center", gap: 0.75, fontSize: 12, color: "text.primary" }}>
          {swatch}
          {item.label}
        </Box>
      );
      return (
        <Box component="li" key={item.key}>
          {item.members ? (
            <Tooltip title={item.members.join(", ")} describeChild>
              {content}
            </Tooltip>
          ) : (
            content
          )}
        </Box>
      );
    })}
  </Box>
);
